var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-row',[_c('v-col',[_c(_vm.selectComp,{tag:"component",attrs:{"reserveList":_vm.reserveList,"reserveSet":_vm.reserveSet},on:{"next-comp":_vm.nextComp,"back-comp":_vm.backComp,"send-confirmation":_vm.sendConfirmation}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }